module.exports = __webpack_public_path__ + "img/philip.ac28518a.png";